import { API } from '@/config/api';
import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Smile, Calendar } from 'lucide-react';
import { toast } from 'sonner';


export default function DailyCheckIn() {
  const [checkedInToday, setCheckedInToday] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await fetch(`${API}/tracking/check-in/history`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setHistory(data);
        
        const today = new Date().toISOString().split('T')[0];
        setCheckedInToday(data.some(c => c.date === today));
      }
    } catch (error) {
      console.error('Failed to fetch history:', error);
    }
  };

  const handleCheckIn = async () => {
    try {
      const response = await fetch(`${API}/tracking/check-in`, {
        method: 'POST',
        credentials: 'include'
      });

      if (response.ok) {
        toast.success('Check-in successful! 🎉');
        setCheckedInToday(true);
        fetchHistory();
      }
    } catch (error) {
      toast.error('Check-in failed');
    }
  };

  return (
    <div className="p-4 md:p-8 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8">Daily Check-In</h1>

      <Card className="p-8 glass-card text-center mb-6">
        <Smile className="h-16 w-16 mx-auto mb-4 text-primary" />
        <h2 className="text-2xl font-bold mb-4">
          {checkedInToday ? "You've checked in today!" : 'Check in for today'}
        </h2>
        <p className="text-muted-foreground mb-6">
          Build your streak by checking in daily
        </p>
        <Button
          onClick={handleCheckIn}
          disabled={checkedInToday}
          size="lg"
        >
          {checkedInToday ? 'Checked In ✓' : 'Check In Now'}
        </Button>
      </Card>

      <Card className="p-6 glass-card">
        <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          Check-In History
        </h3>
        <div className="space-y-2 max-h-96 overflow-y-auto">
          {history.slice(0, 30).map((checkIn, index) => (
            <div
              key={checkIn.check_in_id}
              className="flex items-center justify-between p-3 rounded-lg bg-secondary/50 border border-border"
            >
              <span>{new Date(checkIn.date).toLocaleDateString()}</span>
              <span className="text-success">✓</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
